import { createUseStyles } from '@glu/theming';

const styles = ({ login, spacing }) => ({
  panelLeft: {
    minWidth: 300,
    padding: spacing.unit * 4,
    width: '100%',
    ...(login.form.backgroundColor
      ? {
          backgroundColor: login.form.backgroundColor
        }
      : [])
  },
  logoContainer: {
    display: 'flex'
  },
  logo: {
    display: 'block',
    maxHeight: '40px',
    maxWidth: '100%',
    marginBottom: spacing.unit * 2
  },
  heading1: {
    opacity: 0,
    height: 0,
    width: 0
  }
});

export default createUseStyles(styles);
